import { FeaturedListContextType } from "shared/enums/FeaturedListContextType";
import SelectionRecipientSystemGeneratedList from "./SelectionRecepientList";
import ExhibitorSystemGeneratedList from "./ExhibitorList";
import EmptySystemGeneratedList from "./EmptySystemGeneratedList";

export function getListByFeaturedListContextType(contextType: FeaturedListContextType) {
  switch (contextType) {
    case FeaturedListContextType.SELECTION_RECIPIENT_LIST:
      return new SelectionRecipientSystemGeneratedList();
    case FeaturedListContextType.EXHIBITOR_LIST:
    case FeaturedListContextType.SPONSOR_LIST:
      return new ExhibitorSystemGeneratedList();
    default:
      return new EmptySystemGeneratedList();
  }
}
